export default "__VITE_ASSET__CiKz2Jmq__"